import { TrackableAction } from '../processing';
import { ClosPurchase } from './types';

export class FetchProducts implements TrackableAction {
  readonly track = true;

  static readonly type = '[Subscriptions] Fetch Products';
}

export class FetchCustomerInfo implements TrackableAction {
  readonly track = true;

  static readonly type = '[Subscriptions] Fetch Customer Info';
}

export class ProductPurchase implements TrackableAction {
  readonly track = true;

  constructor(readonly payload: ClosPurchase) {}

  static readonly type = '[Subscriptions] Initialize purchasing';
}
